import type { RouteObject } from 'react-router-dom';

/**
 * «Empezar aquí»: the screen that answers "where am I and what comes next?".
 *
 * It is not one of the inventory's 35: it came out of driving the onboarding by
 * hand and finding that entering the app did not say what to do first. See
 * `StartHerePage.tsx` and `features/onboarding/phase.ts`.
 */
export const getStartedRoutes: RouteObject[] = [
  {
    path: 'get-started',
    lazy: () =>
      import('../pages/StartHerePage').then((m) => ({
        Component: m.StartHerePage,
      })),
  },
  // Where the strip on that screen leads once the clock has run out. It lives
  // inside the shell, not on the entry sequence's centred card: whoever reads
  // it is a customer with an account, not somebody signing up.
  {
    path: 'trial-ended',
    lazy: () =>
      import('../pages/TrialEndedPage').then((m) => ({
        Component: m.TrialEndedPage,
      })),
  },
];
